export default function generateClientMutationId() {
  return Math.random()
    .toString(36)
    .substr(2, 32);
}
